var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinilogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_52_2897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M76.5502 13.1436C80.1797 13.1436 83.122 10.2013 83.122 6.57178C83.122 2.94229 80.1797 0 76.5502 0C72.9207 0 69.9784 2.94229 69.9784 6.57178C69.9784 10.2013 72.9207 13.1436 76.5502 13.1436Z",
    fill: "#FF7043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.1738 80.198C71.0643 65.8292 80.1701 48.1467 80.1701 39.5421C80.1701 25.9808 66.6089 18.5458 56.3613 26.6491C51.9059 30.1299 50.068 28.4592 54.5513 24.8391C58.5055 21.5254 56.1943 21.052 50.9034 24.0037L46.2809 26.8162L50.9034 22.5278C60.8168 13.4499 76.021 12.9486 84.2914 21.5254C89.9164 27.3174 91.5593 39.2079 88.4127 50.5971C86.4356 57.5309 71.5655 82.6485 69.4214 82.6485C68.9201 82.6485 69.2543 81.1726 70.2568 79.5018C73.0693 74.0439 72.0668 73.5427 67.4442 78.026C64.7988 80.1702 59.8421 84.3193 56.1943 86.9369C49.9288 91.5872 49.9288 91.4202 59.1738 80.198Z",
    fill: "#FF7043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.445 13.422C15.0744 13.422 18.0167 10.4797 18.0167 6.85026C18.0167 3.22076 15.0744 0.278473 11.445 0.278473C7.81546 0.278473 4.87317 3.22076 4.87317 6.85026C4.87317 10.4797 7.81546 13.422 11.445 13.422Z",
    fill: "#FF7043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.7258 40.461C12.7258 40.461 22.1101 37.6485 31.3273 29.8236L33.6664 38.2611L21.1633 44.5823L23.1961 52.0173C23.1961 52.0173 29.9071 52.3236 36.4789 47.3391L38.0383 57.0297L27.401 59.5359L42.4102 81.4233C42.4381 81.4233 20.5229 73.5984 12.7258 40.461Z",
    fill: "#029CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.06 29.8236C58.06 29.8236 62.7382 37.008 76.5222 42.0204L75.2691 49.539C75.2691 49.539 69.0037 49.539 67.305 47.3391C67.305 47.3391 64.6596 65.9406 47.4504 82.0637C47.4504 82.0637 58.3941 57.6702 60.594 43.5798L53.7159 37.7877L58.06 29.8236Z",
    fill: "#029CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.8057 86.9647C30.1578 84.3193 25.2012 80.198 22.5557 78.0538C17.9332 73.5984 16.9307 74.0996 19.7432 79.5297C20.7457 81.1726 21.052 82.6763 20.5786 82.6763C18.4345 82.6763 3.56441 57.5588 1.5873 50.625C-1.55936 39.2079 0.0835895 27.2896 5.70859 21.5254C13.979 12.9208 29.1832 13.422 39.0966 22.5278L43.7191 26.8162L39.0966 24.0037C33.8057 21.0241 31.4945 21.5254 35.4487 24.8391C39.9041 28.487 38.0941 30.1299 33.6387 26.6491C23.3911 18.5458 9.82988 25.9808 9.82988 39.5421C9.82988 48.1467 18.9078 65.8292 30.8262 80.198C40.0712 91.4202 40.0712 91.5872 33.8057 86.9647Z",
    fill: "#FF7043"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_2897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 89.8051,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinilogo);
export default __webpack_public_path__ + "static/media/minilogo.1d65251685336472ebf025cb8719a902.svg";
export { ForwardRef as ReactComponent };